import { useState } from "react";
import { Badge } from "../components/ui/badge";
import { X, ChevronDown, ChevronUp } from "lucide-react";

const COVERAGE_TEAM = [
  "Elena Muñoz",
  "Blanca Almendro",
  "Paloma Mingo",
  "Maria Luisa Fombellida",
  "David Redondo",
  "Maria Useros",
];

// Nombre corto para mostrar en badges/tarjetas. Antes usaba solo la primera
// palabra ("Maria"), pero hay 2 personas del equipo cuyo nombre empieza por
// "Maria" (Fombellida y Useros) — sin desambiguar, ambas se veían como el
// mismo "fantasma Maria" en la lista de cobertura (fix 2026-08-24).
export function shortName(fullName) {
  const parts = (fullName || "").trim().split(/\s+/);
  if (parts.length < 2) return fullName;
  const dup = COVERAGE_TEAM.filter(n => n.split(" ")[0] === parts[0]);
  if (dup.length > 1) return `${parts[0]} ${parts[1][0]}.`;
  return parts[0];
}

export { COVERAGE_TEAM };

export default function MultiPersonSelect({ selected, onChange }) {
  const [open, setOpen] = useState(false);
  const toggle = (name) => {
    const next = selected.includes(name)
      ? selected.filter(n => n !== name)
      : [...selected, name];
    onChange(next);
  };

  return (
    <div className="space-y-2">
      <button
        type="button"
        onClick={() => setOpen(!open)}
        className="w-full flex items-center justify-between px-3 py-2 border rounded-md text-sm bg-background hover:bg-accent"
        data-testid="multi-person-select"
      >
        <span className={selected.length === 0 ? "text-muted-foreground" : ""}>
          {selected.length === 0 ? "Sin asignar" : `${selected.length} persona(s)`}
        </span>
        {open ? <ChevronUp className="w-4 h-4" /> : <ChevronDown className="w-4 h-4" />}
      </button>
      {open && (
        <div className="border rounded-md p-2 space-y-1 bg-background shadow-lg">
          {COVERAGE_TEAM.map(name => (
            <label key={name} className="flex items-center gap-2 px-2 py-1.5 rounded hover:bg-accent cursor-pointer text-sm">
              <input type="checkbox" checked={selected.includes(name)} onChange={() => toggle(name)} className="rounded border-gray-300" />
              {name}
            </label>
          ))}
        </div>
      )}
      {selected.length > 0 && (
        <div className="flex flex-wrap gap-1">
          {selected.map(name => (
            <Badge key={name} variant="secondary" className="text-xs">
              {shortName(name)}
              <button onClick={() => toggle(name)} className="ml-1 hover:text-destructive"><X className="w-3 h-3" /></button>
            </Badge>
          ))}
        </div>
      )}
    </div>
  );
}
